import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Alert,
  LatlngConvert,
  UpdateAlert,
  UpdateState,
} from '@classes/alert/alert';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { environment } from '@environments/environment';
import * as moment from 'moment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { Pagination } from '@classes/pagination/pagination';

@Injectable({
  providedIn: 'root',
})
export class alertService {
  constructor(private http: HttpClient) {}

  private alertApi: string = environment.apiUrl + '/alerts';

  alertListChanged = new Subject<any[]>();
  paginationSubject = new BehaviorSubject<Pagination>(null);
  alerts = [];

  private lastQueryObj: {
    from: null;
    to: null;
    state: null;
  };

  getAlert(formValue?): Observable<Alert[]> {
    let httpParams = new HttpParams();

    if (formValue) {
      const filters = formValue;

      const filtersQuery = [];

      if (filters.camera) {
        filtersQuery.push(`cameraId==${filters.camera}`);
      }

      if (filters.state) {
        filtersQuery.push(`state==${filters.state.value}`);
      }

      if (filters.level) {
        filtersQuery.push(`status==${filters.level.value}`);
      }
      if (filters.from && filters.to) {
        filtersQuery.push(
          `date>=${moment(filters.from)
            .startOf('day')
            .utc()
            .format()
            .toString()}`
        );

        filtersQuery.push(
          `date<=${moment(filters.to).endOf('day').utc().format().toString()}`
        );
      }

      httpParams = httpParams.append('Filters', filtersQuery.join());
    }

    return this.http
      .get<Alert[]>(`${this.alertApi}`, {
        params: httpParams,
        headers: { authorization: `Bearer ${environment.tokenKey}` },
      })
      .pipe(
        map((alert) => {
          return alert.filter((alert: Alert) => alert.location !== '0.0,0.0');
        })
      );
  }

  getAlertsWithPagination(request: PaginationRequest) {
    let httpParams = new HttpParams();

    if (request.pageSize && request.page) {
      httpParams = httpParams
        .append('pageSize', request.pageSize.toString())
        .append(
          'page',
          request.query !== this.lastQueryObj ? '1' : request.page.toString()
        );
    }

    if (request.query) {
      const filters = request.query;

      const filtersQuery = [];

      if (filters.state) {
        filtersQuery.push(`state==${filters.state.value}`);
      }

      if (filters.from && filters.to) {
        filtersQuery.push(
          `date>=${moment(filters.from)
            .startOf('day')
            .utc()
            .format()
            .toString()}`
        );

        filtersQuery.push(
          `date<=${moment(filters.to).endOf('day').utc().format().toString()}`
        );
      }

      httpParams = httpParams.append('Filters', filtersQuery.join());

      this.lastQueryObj = request.query;
    }

    if (request.sort) {
      httpParams = httpParams.append('sorts', request.sort);
    }

    this.http
      .get<any[]>(`${this.alertApi}`, {
        params: httpParams,
        observe: 'response',
      })
      .subscribe((result: HttpResponse<any[]>) => {
        this.alerts = result.body;
        this.alertListChanged.next([...this.alerts]);
        const pagination: Pagination = JSON.parse(
          result.headers.get('X-Pagination')
        );
        this.paginationSubject.next({ ...pagination });
      });
  }

  exportAlert(request: PaginationRequest) {
    let httpParams = new HttpParams();

    if (request.query) {
      const filters = request.query;

      const filtersQuery = [];

      if (filters.from && filters.to) {
        filtersQuery.push(
          `date>=${moment(filters.from)
            .startOf('day')
            .utc()
            .format()
            .toString()}`
        );

        filtersQuery.push(
          `date<=${moment(filters.to).endOf('day').utc().format().toString()}`
        );
      }

      if (filters.state) {
        filtersQuery.push(`state==${filters.state.value}`);
      }

      httpParams = httpParams.append('Filters', filtersQuery.join());
    }

    return this.http
      .get(`${this.alertApi}/excel`, {
        params: httpParams,
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(map((res) => this.saveFile(res)));
  }

  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    return res.body;
  }

  putEtat(id: string, state: UpdateState) {
    return this.http.put<UpdateState[]>(
      `${environment.apiUrl}/alerts/${id}/state`,
      state
    );
  }

  putAlert(id: string, status: UpdateAlert) {
    if (status.status === 'null') {
      status.status = null;
    }
    return this.http.put<UpdateAlert[]>(
      `${environment.apiUrl}/alerts/${id}/status`,
      status
    );
  }
}
